import copyLink from './copy-link.js';
import print from './print.js';

export default {
  print,
  copyLink,
};
